var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',{staticClass:"text-4xl font-bold m-4"},[_vm._v("Page NotFound")])])
}]

export { render, staticRenderFns }